'use client'
import { usePathname } from 'next/navigation'

import GoogleAds from '@/shared/google-ads'
import adsData from '@/shared/google-ads/adsData.json'

export default function StickyBottomAdd() {
  const { mobSticky } = adsData.data
  const pathname = usePathname()
  if (pathname === '/') return null
  return (
    <div className={`md:hidden flex fixed bottom-14 text-center start-0 end-0 min-h-12`}>
      <GoogleAds {...mobSticky} />
    </div>
  )
}
